import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class PricePermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.priceRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.priceImport,
    );
    this.priceAutocomplete = permissionChecker.match(
      Permissions.values.priceAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.priceCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.priceEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.priceDestroy,
    );
  }
}
